var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPackage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "mramdcnv0a",
    d: "M13.335.313l8 4C22.355 4.82 23 5.86 23 7v9.53c0 1.139-.645 2.179-1.663 2.684l-8 4c-.844.423-1.84.423-2.684 0L2.65 19.212C1.632 18.699.992 17.652 1 16.519v-9.52c0-1.139.646-2.179 1.663-2.684l3.81-1.906c.048-.03.1-.056.152-.077l4.04-2.019c.841-.417 1.83-.417 2.67 0zM3 7.377v9.149c-.003.38.21.729.547.899L11 21.15v-9.774l-8-4zm18 0l-8 4v9.768l7.445-3.722c.34-.168.555-.515.555-.894V7.377zM7.005 4.379L4.241 5.761l7.76 3.88 2.762-1.382-7.758-3.88zm4.552-2.276L9.241 3.261 17 7.14l2.758-1.379-7.314-3.657c-.28-.139-.609-.139-.887 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-249 -1184) translate(0 1175) translate(249 9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mq5dix8yib",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mramdcnv0a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#mramdcnv0a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M0 0H24V24H0z",
    mask: "url(#mq5dix8yib)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.0ee64aa0.svg";
export { ForwardRef as ReactComponent };